import { render, staticRenderFns } from "./AddPieTDWidget.vue?vue&type=template&id=1d0adc98"
import script from "./AddPieTDWidget.vue?vue&type=script&lang=js"
export * from "./AddPieTDWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports